<template>
  <div class="player_performance_cnt">
    <div class="performance_block">
      <div class="team_title">
        <figure>
          <img :src="game.HomeTeam.logo" />
        </figure>
        <figcaption>{{ game.HomeTeam.Name }} Scoring</figcaption>
      </div>
      <div class="perfomance_subtabs">
        <ul>
            <li  v-bind:class="{ active: selectedhtype == 1 }"  @click="reloadCharrHome('Points',1)" >Scoring</li> 
            <li  v-bind:class="{ active: selectedhtype == 2 }"  @click="reloadCharrHome('Steals',2)" >Steals</li> 
            <li  v-bind:class="{ active: selectedhtype == 3 }"  @click="reloadCharrHome('DefensiveRebounds',3)" >Defensive <br/>Rebounds</li> 
            <li  v-bind:class="{ active: selectedhtype ==4 }"  @click="reloadCharrHome('OffensiveRebounds',4)" >Offensive <br/>Rebounds</li> 
            <li  v-bind:class="{ active: selectedhtype == 5 }"  @click="reloadCharrHome('Assists',5)" >Assists</li> 
            <li  v-bind:class="{ active: selectedhtype == 7 }"  @click="reloadCharrHome('BlockedShots',7)" >Blocks</li> 

                      
        </ul> 
      </div>
      <div class="perfomance_chart">
        <div
          id="chartdiv"
          class="oddschart"
          style="min-height: auto; height: 320px; padding-top: 60px"
        ></div>
      </div>
    </div>
    <div class="performance_block">
      <div class="team_title">
        <figure>
          <img :src="game.AwayTeam.logo" />
        </figure>
        <figcaption>{{ game.AwayTeam.Name }} Scoring</figcaption>
      </div>
      <div class="perfomance_subtabs">
        <ul>
         
   <li  v-bind:class="{ active: selectedatype == 1 }"  @click="reloadCharrAwy('Points',1)" >Scoring</li> 
            <li  v-bind:class="{ active: selectedatype == 2 }"  @click="reloadCharrAwy('Steals',2)" >Steals</li> 
            <li  v-bind:class="{ active: selectedatype == 3 }"  @click="reloadCharrAwy('DefensiveRebounds',3)" >Defensive <br/>Rebounds</li> 
            <li  v-bind:class="{ active: selectedatype ==4 }"  @click="reloadCharrAwy('OffensiveRebounds',4)" >Offensive <br/>Rebounds</li> 
            <li  v-bind:class="{ active: selectedatype == 5 }"  @click="reloadCharrAwy('Assists',5)" >Assists</li> 
            <li  v-bind:class="{ active: selectedatype == 7 }"  @click="reloadCharrAwy('BlockedShots',7)" >Blocks</li> 

    

        </ul> 
      </div>
      <div class="perfomance_chart" >
        <div id="chartdiv2spb" class="oddschart"  style="min-height: auto; height: 320px; padding-top: 60px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_dark from "@amcharts/amcharts4/themes/dark";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_dark);
am4core.useTheme(am4themes_animated);
var _starsystemchart;
export default {
  props: {
    game: null,
    gameId: null,
  },
  data: function () {
    return {
      selectedhtype:1,
      selectedatype:1,
      activeitem:1,
      activeitem1:1,
      showMobileMenu: false,
      htab: 1,
      firstloading: true,
      timeInterval: "D",
      selecteddates: null,
      shotsloading: false,
      noshots: false,
      tdateperiod: null,
      tselectedvalues: {},

      Prediction: null,
      options: {
        height: "100%",
        size: 5,
      },
      selectedones: ["awayscore", "homescore"],
      tendencies: ["awayscore", "homescore"],
      colors: [],
      tendenciesdata: [],
      chartInstances: {}, // Store chart instances for disposal
    };
  },
  methods: {
     reloadCharrHome(typpe,selectedhtype){
        if (this.Prediction && this.Prediction.HomeLineup && Array.isArray(this.Prediction.HomeLineup)) {
          this._drawodds(
            this.Prediction.HomeLineup,
            this.game.HomeTeam.PrimaryColor,
            "chartdiv",
            typpe
          );
        }
        this.selectedhtype = selectedhtype
    },
    reloadCharrAwy(typpe,selectedhtype){
     
        if (this.Prediction && this.Prediction.AwayLineup && Array.isArray(this.Prediction.AwayLineup)) {
          this._drawodds(
            this.Prediction.AwayLineup,
            this.game.AwayTeam.PrimaryColor,
            "chartdiv2spb",
            typpe
          );
        }
        this.selectedatype = selectedhtype
    },
    _drawodds(lineup, PrimaryColor, divId, type) {
      var _self = this;
      if (!lineup || !Array.isArray(lineup) || lineup.length === 0) {
        return;
      }
      
      // Dispose existing chart if it exists
      if (this.chartInstances[divId]) {
        this.chartInstances[divId].dispose();
        delete this.chartInstances[divId];
      }
      
      setTimeout(function () {
        // Sort by the selected stat type, not just Points
        var sortField = type === "Points" ? "Points" : type;
        // Sort manually if lodash is not available
        var sorteddata = lineup.slice().sort(function(a, b) {
          var aVal = a[sortField] || 0;
          var bVal = b[sortField] || 0;
          return bVal - aVal; // Descending order
        });

        var chart = am4core.create(divId, am4charts.XYChart);
        // Store chart instance for later disposal
        _self.chartInstances[divId] = chart;
        
        chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

        chart.paddingBottom = 30;

        var _usersdata = [];
        sorteddata.forEach(function (item, index) {
          if (index <= 9) {
            // Build player name from FirstName/LastName or use Name if available
            var playerName = item.Name || (item.FirstName && item.LastName ? 
              (item.FirstName + " " + item.LastName).trim() : 
              (item.FirstName || item.LastName || "Unknown"));
            
            // Get the stat value for the selected type (default to 0 if missing)
            var statValue = item[type];
            if (statValue === undefined || statValue === null || isNaN(statValue)) {
              statValue = 0;
            }
            
            
            // Don't skip players with 0 stats - show all players (different stat types will have different values)
            // Only skip if the value is truly missing/undefined
            
            // Create avatar initials from name
            var initials = "";
            if (playerName) {
              var nameParts = playerName.split(" ").filter(function(part) { return part.length > 0; });
              if (nameParts.length >= 2) {
                initials = (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
              } else if (nameParts.length === 1) {
                initials = nameParts[0].substring(0, 2).toUpperCase();
              }
            }
            
            _usersdata.push({
              name: playerName,
              points: statValue,
              color: am4core.color("#" + PrimaryColor),
              initials: initials,
            });
          }
        });
        
        // If no data, return early
        if (_usersdata.length === 0) {
          return;
        }
        chart.data = _usersdata;
        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "name";
        categoryAxis.renderer.grid.template.disabled = true;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
        categoryAxis.renderer.labels.template.fontSize = 6;
        let categoryLabel = categoryAxis.renderer.labels.template;

        categoryLabel.wrap = true;
        categoryLabel.textAlign = "middle";
        categoryLabel.maxWidth = 120;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.grid.template.strokeDasharray = "4,4";
        valueAxis.renderer.labels.template.disabled = true;
        valueAxis.min = 0;

        // Do not crop bullets
        chart.maskBullets = false;

        // Remove padding
        chart.paddingBottom = 0;

        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "points";
        series.dataFields.categoryX = "name";
        series.columns.template.propertyFields.fill = "color";
        series.columns.template.propertyFields.stroke = "color";

        series.columns.template.tooltipText = "{categoryX}: [bold]{valueY} "+type+"[/b]";

        // Add avatar circles with initials instead of images
        var bullet = series.bullets.push(new am4charts.Bullet());
        
        // Create circle for avatar
        var circle = bullet.createChild(am4core.Circle);
        circle.radius = 16;
        circle.horizontalCenter = "middle";
        circle.verticalCenter = "bottom";
        circle.fill = am4core.color("#" + PrimaryColor);
        circle.stroke = am4core.color("#ffffff");
        circle.strokeWidth = 2;
        circle.tooltipText = series.columns.template.tooltipText;
        circle.filters.push(new am4core.DropShadowFilter());
        
        // Add text for initials inside the circle
        var label = bullet.createChild(am4core.Label);
        label.text = "{initials}";
        label.horizontalCenter = "middle";
        label.verticalCenter = "middle";
        label.fill = am4core.color("#ffffff");
        label.fontSize = 8;
        label.fontWeight = "bold";
        label.dy = -16; // Position to center in circle

        // Position bullet above the column
        bullet.adapter.add("dy", function (dy, target) {
          if (target.dataItem && target.dataItem.itemHeight) {
            return target.dataItem.itemHeight + 10;
          }
          return 10;
        });

        //  categoryAxis.renderer.labels.template.location = 0.0001;
      }, 200);
    },
    _showhideline(_index) {
      let series = _starsystemchart.series.getIndex(_index);
      if (series.isHiding || series.isHidden) {
        series.show();
      } else {
        series.hide();
      }
    },
    changeLineup(lineup) {
      this._drawodds(lineup);
    },
    _getodds() {
      this.noshots = false;
      this.shotsloading = true;
      var self = this;
      
      // Check if gameId is available
      if (!this.gameId) {
        //console.warn("[probteamperformance] gameId prop is not set! gameId:", this.gameId, "game:", this.game);
        // Try to get gameId from game prop
        if (this.game && this.game.gameid) {
         // console.log("[probteamperformance] Using game.gameid:", this.game.gameid);
          this.gameId = this.game.gameid;
        } else if (this.game && this.game._id) {
        //  console.log("[probteamperformance] Using game._id:", this.game._id);
          this.gameId = this.game._id;
        } else if (this.game && this.game.gameId) {
        //  console.log("[probteamperformance] Using game.gameId:", this.game.gameId);
          this.gameId = this.game.gameId;
        } else {
       //   console.error("[probteamperformance] Cannot find gameId from props! game object:", this.game);
          this.shotsloading = false;
          return;
        }
      }
      
      if (!this.gameId) {
       // console.error("[probteamperformance] Still no gameId after fallback attempts!");
        this.shotsloading = false;
        return;
      }
      
      var postdata = {
        gameId: this.gameId,
      };
      //console.log("[probteamperformance] Requesting currentgame with gameId:", this.gameId);
      
      this.$store.dispatch("getcurrentgame", postdata).then((response) => {
        this.Prediction = response;
        this.shotsloading = false;

        if (this.Prediction && this.Prediction.HomeLineup && Array.isArray(this.Prediction.HomeLineup)) {
          this._drawodds(
            this.Prediction.HomeLineup,
            this.game.HomeTeam.PrimaryColor,
            "chartdiv",
            "Points"
          );
        }

        if (this.Prediction && this.Prediction.AwayLineup && Array.isArray(this.Prediction.AwayLineup)) {
          this._drawodds(
            this.Prediction.AwayLineup,
            this.game.AwayTeam.PrimaryColor,
            "chartdiv2spb",
            "Points"
          );
        }
      }).catch((error) => {
        this.shotsloading = false;
      });
    },
  },
  watch: {},
  mounted() {
    var self = this;
    this.colors = this.chartcolors;

    this._getodds();
  },
};
</script>
